const InputRadio = (props) => {
	return (
		<input
			type='radio'
			name={'name-' + props.question.id}
			value={props.item.id}
			id={props.item.id}
			checked={props.item.selected || false}
			disabled={props.disabled}
			onChange={() => props.dispatch(props.onChangeContentQuiz(props.index))}
			className={`answer-input${
				props.question.type === 6 ? ' hidden-radio-button' : ''
			}`}
		/>
	)
}

export default InputRadio
